import { useEffect } from 'react';

const BASE_TITLE = 'CASA IN GOLD';
const SUFFIX = 'Móveis de Alto Padrão';

/**
 * Hook para definir o título da página dinamicamente
 * @param {string} pageTitle - Título específico da página (opcional)
 * @param {boolean} includeBase - Se deve incluir o nome da marca (default: true)
 */
export const usePageTitle = (pageTitle = '', includeBase = true) => {
  useEffect(() => {
    if (pageTitle) {
      document.title = includeBase 
        ? `${pageTitle} | ${BASE_TITLE}` 
        : pageTitle;
    } else {
      document.title = `${BASE_TITLE} | ${SUFFIX}`;
    }
    
    // Cleanup: restaurar título base quando componente desmontar
    return () => {
      document.title = `${BASE_TITLE} | ${SUFFIX}`;
    };
  }, [pageTitle, includeBase]);
};

export default usePageTitle;
